import { FilterItem } from "../../../../../../../dashboard/reports/components/table/utils/styled";
import FormControl from "@mui/material/FormControl";
import { InputLabel, NativeSelect } from "../../../../../../../../common/styles/muiStyled";
import React, { useEffect, useState } from "react";
import { FilterProps } from "../../../../../../types";
import { useTranslation } from "react-i18next";
import { SelectChangeEvent } from "@mui/material/Select";
import { useSelector } from "react-redux";
import { productsSelector } from "../../../../../../../../redux/magento/selectors/magento.selectors";
import { IProduct, LabelValue } from "../../../../../../../../common/types";
import { mapAndSortFilterCompanyValues } from "./utils/utils";

type Props = Omit<FilterProps, "config" | "filterTableData">;

export const BadgeProductFilter = ({ filterGetters, filterSetters }: Props) => {
  const { t, i18n } = useTranslation("common");
  const [sortedLabelsWithPrice, setList] = useState<LabelValue[]>([]);
  const products: IProduct[] = useSelector(productsSelector);

  const onChange = (e: SelectChangeEvent) => {
    filterSetters.onBadgeProductChange(e.target.value);
  };
  useEffect(() => {
    setList(mapAndSortFilterCompanyValues(filterGetters.productOptions, products, i18n.language));
  }, []);

  return (
    <FilterItem>
      <FormControl fullWidth>
        <InputLabel>{t("companyPage.badgeProduct")}</InputLabel>
        <NativeSelect value={filterGetters.selectedProduct} onChange={onChange}>
          {sortedLabelsWithPrice.map(row => (
            <option value={row.value} key={row.value}>
              {row.label}
            </option>
          ))}
        </NativeSelect>
      </FormControl>
    </FilterItem>
  );
};
